import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({ standalone: false,
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  title: string= "Title";
  message: string = "Are you sure?";
  confirmButtonText = "Yes";
  cancelButtonText = "Cancel";

  public reasonForm:FormGroup;
  public needReason:boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
    this.reasonForm = new FormGroup({
      reason: new FormControl<string | undefined>(undefined, Validators.compose([Validators.required, Validators.minLength(5)]))
    });
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        this.needReason = data.needReason || this.needReason;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
  }

  canConfirm(){
    return (!this.needReason || this.reasonForm.valid);
  }

  onConfirmClick(): void {
    if(!this.needReason) this.dialogRef.close(true);
    else this.dialogRef.close(this.reasonForm.get('reason')!.value);
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}